import { Component, NgZone, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { AppdataService } from 'src/app/services/app-data/appdata.service';
import { WebsocketService } from 'src/app/services/websockets/websocket.service';
import { $b } from '../../../libs/browser_utils.js';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WelcomeComponent implements OnInit {
  logoImg: any;
  appConfig: any;
  isCaptchaEnabled: boolean;
  encryptKey = 'ThisIsTheSecret';
  version: string;

  constructor(private route: Router, private appDataService: AppdataService, private websocketService: WebsocketService, public zone: NgZone) {
    console.log('%c WelcomeComponent', 'color:white; background: blue;');
  }

  ngOnInit(): void {
    this.appConfig = this.appDataService.getConfig();

    // if (Object.keys(this.appConfig).length === 0 && this.appConfig.constructor === Object) {
    //   this.decryptAppConfig();
    // }

    this.version = this.appConfig.version;
    this.logoImg = this.appConfig.welcomeLogo; // get the welcome logo
    this.isCaptchaEnabled = this.appConfig.isCaptchaEnabled; // see if the captcha is enabled

    if (history.state && history.state.reload) {
      location.reload();
    } else {
      /**
       * Route to captcha if captcha is enabled
       */
      if (this.isCaptchaEnabled === true) {
        setTimeout(() => {
          const navigationExtras: NavigationExtras = {
            queryParamsHandling: 'preserve',
            preserveFragment: true
          };
          this.zone.run(() => { 
            this.route.navigate(['/captcha'], navigationExtras); // route to captcha if enabled
          });
        }, 3000);
      } else if (this.isCaptchaEnabled === false) {
        /**
         * Start websocket directly
         */
        // Session start will be handled in AppComponent - HandleOpenFailed
        if (this.appConfig.websocket.enabled) {
          this.websocketService.startWebSocket();
        }
      }
    }
  }

  /**
   * Decrypt the app-config fetched from localstorage
   */
  decryptAppConfig() {
    const decryptData = CryptoJS.AES.decrypt($b.GetLocalStorage('appconfig'), this.encryptKey);
    const obj = JSON.parse(decryptData.toString(CryptoJS.enc.Utf8));
    this.appConfig = obj;
  }
}
